import { render, staticRenderFns } from "./VersionMsg.vue?vue&type=template&id=2ebcf150"
import script from "./VersionMsg.vue?vue&type=script&lang=js"
export * from "./VersionMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports